import BackButton from '@sharedComponents/BackButton/BackButton';
import NeedHelp from '@sharedComponents/NeedHelp/NeedHelp';
import {ThemedView} from '../../../../theme'
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import {  View } from 'react-native';
import gs from '@app/styles/globalStyles';
import { useDarkMode } from '@app/utils';


type VerifyPanHeaderProps = {
  navigation : NativeStackNavigationProp<PrivateStackParamList>,
  pageName: keyof PrivateStackParamList
}


const VerifyPanHeader = ({ navigation , pageName } : VerifyPanHeaderProps) => {
  return (
    <ThemedView
    flexDirection='row'
    justifyContent='space-between'
    bg={'bg-surface-primary'}
    paddingHorizontal='lg'
    borderBottomWidth={1}
    borderBottomColor='border-primary'
    height={60}
    alignItems='center'>
      <ThemedView flexDirection='row'>
        <BackButton pageName={pageName} navigation={navigation} />
      </ThemedView>
      <NeedHelp />
    </ThemedView>
  );
};

export default VerifyPanHeader;
